// extracted by mini-css-extract-plugin
export default {"container":"CZYRkgYurinvsySnWqog","title":"fDsKuea8eAIA8wdVtbp0","actions":"zi5txUoiTDKJnq47xsi0","tryAgainButton":"u1QseAw3MJJRbIWAeYqm","pulse":"PERQFf7FYRw5Oik0zlPz"};